import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import CustomTextField from 'components/Input/CustomTextField';
import React, { useState, useEffect } from 'react';
import useSearchMember from './useSearchMember';
import { Grid } from '@material-ui/core';
import CustomPagination from 'components/CustomPagination';
import PageSize from 'components/CustomTable/PageSize';
import Popup from 'components/popup/popup';
import { GET_MEETING_ARRANGEMENT_MEMBER_LIST } from 'store/key';
import { useDispatch, useSelector } from 'react-redux';
import { SELECT_ONE_REVIEWER } from 'utility/frontendMessage';
import useDialog from 'components/ConfirmDialog/useDialog';
import { cloneDeep } from 'lodash';
const AddPanelMemberDialog = ({ isEditMode, handleSave, panelMemberList = [] }) => {
    const showDialog = useDialog();
    const dispatch = useDispatch();
    const [selectedRows, setSelectedRows] = useState([]);
    const [specialList, setSpecialList] = useState([]);
    const { meetingArrangementMemberList } = useSelector((state) => state.arrangeMeeting);
    const [selectedList, setSelectedList] = useState(panelMemberList);

    const [isMemberLoading, setIsMemberLoading] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({ paramValue: '', paramKey: 'panel', page: 1, pageSize: 10 });
    const [openPopup, setOpenPopup] = useState(false);
    const [isSeach, setIsSeach] = useState({ paramValue: '', paramKey: 'panel', page: 1, pageSize: 10 });

    const { columns, currentColumns, addColumns } = useSearchMember({
        selectedRows,
        setSelectedRows,
        meetingArrangementMemberList,
        isEditMode,
        specialList,
    });

    let listOfCriteria = [
        { display: 'Panel', key: 'panel' },
        { display: 'Surname', key: 'surname' },
        { display: 'First name', key: 'firstName' },
    ];

    useEffect(() => {
        if (openPopup) {
            // setSearchCriteria({ paramKey: 'panel', paramValue: '', page: 1, pageSize: 10, total: 1 })
            setSelectedRows(selectedList);
            getReviewPanelMemberList(searchCriteria);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openPopup]);

    useEffect(() => {
        setSelectedList(panelMemberList);
    }, [panelMemberList]);

    useEffect(() => {
        let memberList = cloneDeep(meetingArrangementMemberList?.data) || [];
        let newMemberList = [];
        memberList.forEach((item) => {
            if (!item.reviewPanels) return;
            if (item.reviewPanels.length > 0) {
                item.reviewPanels.forEach((ele) => {
                    newMemberList.push({
                        ...item,
                        specialId: item.id,
                        id: item.id,
                        reviewPlanName: ele.panelName,
                        list: [ele],
                        panelNameId: ele.id,
                    });
                });
            } else {
                newMemberList.push({
                    ...item,
                    specialId: item.id,
                    id: item.id,
                    reviewPlanName: null,
                    list: [],
                    panelNameId: null,
                });
            }
        });

        let spcList = [...newMemberList];
        if (isSeach.paramKey === 'panel' && isSeach.paramValue) {
            spcList = newMemberList.reduce((group, curP) => {
                if (curP?.reviewPlanName?.toLowerCase().indexOf(isSeach.paramValue.toLowerCase()) !== -1) {
                    return group.concat(curP);
                }
                return group;
            }, []);
        }
        setSpecialList(spcList);
    }, [meetingArrangementMemberList, isSeach]);

    const getReviewPanelMemberList = (params) => {
        if (params.paramValue.length >= 255) return;
        setIsMemberLoading(true);
        dispatch({
            type: GET_MEETING_ARRANGEMENT_MEMBER_LIST,
            payload: {
                params,
                callback: () => {
                    setIsMemberLoading(false);
                    setIsSeach(params);
                },
            },
        });
    };

    const deleteSelectedRow = (row, isAdd) => {
        const index = selectedRows.findIndex((item) => item.id === row.id);
        if (index !== -1) {
            const newSelectedRows = [...selectedRows];
            newSelectedRows.splice(index, 1);
            setSelectedRows(newSelectedRows);
            if (isAdd) {
                handleSave({ panelMemberList: newSelectedRows });
                setSelectedList(newSelectedRows);
            }
        }
    };

    const handleConfirm = () => {
        if (selectedRows.length === 0) {
            showDialog({
                description: SELECT_ONE_REVIEWER,
                disableCancelButton: true,
            });
            return;
        }
        setOpenPopup(false);
        setSelectedList(selectedRows);
        handleSave({ panelMemberList: selectedRows });
    };

    const handleClear = () => {
        setSearchCriteria({ paramValue: '', paramKey: 'panel', page: 1, pageSize: 10 });
        getReviewPanelMemberList({
            paramValue: '',
            paramKey: 'panel',
            page: 1,
            pageSize: 10,
            // sort: 'email',
            // isDesc: true,
        });
    };

    const setDisabled = () => {
        if (
            isSeach.paramKey === 'panel' &&
            isSeach.paramValue === '' &&
            isSeach.page === 1 &&
            isSeach.pageSize === 10
        ) {
            return true;
        } else {
            return false;
        }
    };

    const handCancel = () => {
        setOpenPopup(false);
        setSearchCriteria({ paramKey: 'panel', paramValue: '', page: 1, pageSize: 10, total: 1 });
    };

    return (
        <div>
            <Popup
                title="Add Panel Member"
                width="80%"
                open={openPopup}
                footerActions={[
                    { label: 'Cancel', clicked: handCancel, color: 'default' },
                    { label: 'Confirm', clicked: handleConfirm },
                ]}
                closePopup={() => setOpenPopup(false)}
            >
                <div style={{ width: '100%' }}>
                    <div
                        style={{
                            display: 'flex',
                            marginTop: 15,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <TextSubHeader style={{ paddingRight: 10 }}>Search Panel Member: </TextSubHeader>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Grid container alignItems="center" wrap="nowrap">
                                <div style={{ marginRight: 5 }}>
                                    <CustomOutlineSelect
                                        label="Criteria"
                                        value={searchCriteria.paramKey}
                                        onChange={(e) => {
                                            setSearchCriteria({ ...searchCriteria, paramKey: e.target.value, page: 1 });
                                            getReviewPanelMemberList({
                                                ...searchCriteria,
                                                paramKey: e.target.value,
                                                page: 1,
                                            });
                                        }}
                                        choices={listOfCriteria}
                                    />
                                </div>
                                <div style={{ width: 400, marginRight: 5 }}>
                                    <CustomTextField
                                        label={'Keyword'}
                                        value={searchCriteria.paramValue}
                                        maxLength={255}
                                        onChange={(e) =>
                                            setSearchCriteria({ ...searchCriteria, paramValue: e.target.value })
                                        }
                                        onPressEnter={() => {
                                            setSearchCriteria({ ...searchCriteria, page: 1 });
                                            getReviewPanelMemberList({ ...searchCriteria, page: 1 });
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid container alignItems="center" style={{ marginRight: 10 }}>
                                <PageSize
                                    label="Page Size"
                                    value={searchCriteria.pageSize}
                                    onChange={(pageSize) => {
                                        setSearchCriteria({ ...searchCriteria, page: 1, pageSize });
                                        getReviewPanelMemberList({ ...searchCriteria, page: 1, pageSize });
                                    }}
                                />
                            </Grid>
                            <CustomButton
                                disabled={searchCriteria.paramValue === ''}
                                style={{ height: 38 }}
                                onClick={() => {
                                    setSearchCriteria({ ...searchCriteria, page: 1 });
                                    getReviewPanelMemberList({ ...searchCriteria, page: 1 });
                                }}
                            >
                                Search
                            </CustomButton>
                            <CustomButton
                                style={{ marginLeft: 5, height: 38 }}
                                onClick={handleClear}
                                disabled={setDisabled()}
                            >
                                Reset
                            </CustomButton>
                        </div>
                    </div>
                    <div style={{ marginTop: 15 }}>
                        <CustomTable
                            loading={isMemberLoading}
                            // rows={meetingArrangementMemberList?.data || []}
                            rows={specialList || []}
                            columns={columns}
                            skipMaxHeight={false}
                            maxHeight={280}
                        />
                    </div>
                    <div style={{ margin: '10px 0' }}>
                        <CustomPagination
                            page={meetingArrangementMemberList?.page || 1}
                            pageSize={meetingArrangementMemberList?.size || 10}
                            total={meetingArrangementMemberList?.total || 0}
                            onPageChange={(page) => {
                                setSearchCriteria({ ...searchCriteria, page });
                                getReviewPanelMemberList({ ...searchCriteria, page });
                            }}
                        />
                    </div>

                    <div style={{ borderTop: '2px solid #dcdcdc', marginTop: 15 }}></div>

                    <TextSubHeader style={{ marginTop: 15 }}>Added Member:</TextSubHeader>
                    <div style={{ marginTop: 15 }}>
                        <CustomTable
                            rows={selectedRows}
                            columns={addColumns}
                            isDeleteAllow
                            onDelete={(item) => deleteSelectedRow(item)}
                            skipMaxHeight={false}
                            maxHeight={280}
                        />
                    </div>
                </div>
            </Popup>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextSubHeader>Panel Member:</TextSubHeader>
                {isEditMode && (
                    <CustomButton style={{ marginLeft: 10 }} onClick={() => setOpenPopup(true)}>
                        Add
                    </CustomButton>
                )}
            </div>

            <div style={{ marginTop: 20 }}>
                <CustomTable
                    isDeleteAllow={isEditMode}
                    onDelete={(item) => deleteSelectedRow(item, true)}
                    columns={currentColumns}
                    rows={selectedList}
                    allowResize
                    fullWidthTable={true}
                />
            </div>
        </div>
    );
};

export default AddPanelMemberDialog;
